import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
//Component
import { Modal } from "../../stories/modal";
import FormInput from "../../stories/hook-controls/input";
import { ReactTable } from "../../stories/react-table";
//Function
import { setDataToFormHookV2, isEmptyStr } from "../../utils/common-function";
import { formatDateTime } from "../../utils/common-function"
import { getHistoryColumns } from "./columns/export-history";
import { TextField, Divider } from "@material-ui/core";


function ViewDetail(props) {
  const { open } = props;
  const { Detail, ...otherprops } = props;

  const method = useForm();
  const { setValue } = method;

  useEffect(() => {
    if (!open) return;
    if (typeof Detail === "undefined") return;

    let data = setDataToFormHookV2(Detail);
    //console.log(data);
    setTimeout(() => data?.forEach(({ name, value }) => {
        if(name === "ENCRYPT_STATUS"){
            let newStatus = (value === "SUCCESS" || value === "Error" || value === "FAILED") ? (value === "FAILED") ? "Error" : value : value === "No Decrypt" ? "SUCCESS" : "Running";
            setValue(name, newStatus);
          }
          else{
            setValue(name, value);
          }
          }));
  }, [Detail, setValue, open]);

  return (
    <Modal
      {...otherprops}
      hiddenSave={true}
      title="View Decrypt Detail"
      maxWidth={false}
    >
      <FormProvider {...method}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <FormInput
                InputProps={{
                  readOnly: true,
                }}
                variant="filled"
                name="DOWNLOAD_ID"
                label="DOWNLOAD ID"
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <FormInput
                InputProps={{
                  readOnly: true,
                }}
                variant="filled"
                name="HOST_NAME"
                label="HOST NAME"
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <FormInput
                InputProps={{
                  readOnly: true,
                }}
                variant="filled"
                name="REASON"
                label="REASON"
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <FormInput
                InputProps={{
                  readOnly: true,
                }}
                variant="filled"
                name="SPI_TEXT"
                label="APPLICATION"
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <FormInput
                InputProps={{
                  readOnly: true,
                }}
                variant="filled"
                name="ENCRYPT_STATUS"
                label="STATUS"
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box flexGrow={1} className="box-input">
              <TextField
                id="outlined-textarea"
                name="ERROR_MESSAGE"
                label="ERROR MESSAGE "
                //placeholder="Sql query here ..."
                multiline
                variant="filled"
                rows={10}
                fullWidth
                disabled={true}
                value={Detail?.ERROR_MESSAGE ?? ""}
              />
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  );
}
export default ViewDetail;
